import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.css';
import cx from 'classnames';
import cs from '../../components/commonStyle.css';
import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';

// Component
import Link from '../Link';
import getLocalizedContent from '../../core/helpers/getLocalizedContent';

//Images
import PlayStoreImage from '/public/siteImages/playStore.svg';
import AppStoreImage from '/public/siteImages/appStore.svg';
import bgImage from '/public/siteImages/footernewBg.svg';
import facebookIcon from '/public/SiteIcons/facebookIcon.svg';
import twitterIcon from '/public/SiteIcons/twitterLogo.svg';
import instaIcon from '/public/SiteIcons/instagramIcon.svg';
import youtubeIcon from '/public/SiteIcons/youtubeIcon.svg';
import linkedinIcon from '/public/SiteIcons/linkedinIcon.svg';
import whiteFooter from '/public/siteImages/whiteFooterWave.svg';
// Locale
import messages from '../../locale/messages';

import getEnabledBlog from './getEnabledBlog.graphql';
import getPopularLocations from './getPopularLocations.graphql';
import getPopularSearches from './getPopularSearches.graphql';

class Footer extends React.Component {

  static propTypes = {
    siteName: PropTypes.string.isRequired,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    youtube: PropTypes.string,
    linkedin: PropTypes.string,
    appAvailableStatus: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    playStoreUrl: PropTypes.string,
    appStoreUrl: PropTypes.string,
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getEnabledBlog: PropTypes.array,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      rentall: false,
      hosting: false,
      discover: false,
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data: { getEnabledBlog }, siteName } = nextProps;
    getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
      if (item.footerCategory != 'discover' && item.footerCategory != 'hosting') {
        this.setState({ rentall: true })
      }
      if (item.footerCategory == 'discover') {
        this.setState({ discover: true })
      }
      if (item.footerCategory == 'hosting') {
        this.setState({ hosting: true })
      }
    });
  }

  render() {
    const { siteName, facebook, twitter, instagram, youtube, linkedin, appAvailableStatus, playStoreUrl, appStoreUrl, footerMargin, whiteBg, isAuthenticated, page, locale } = this.props;
    const { data: { getEnabledBlog } } = this.props;
    const { popularLocationsData, popularSearchesData } = this.props;
    const popularLocations = popularLocationsData?.getPopularLocation || [];
    const popularSearches = popularSearchesData?.getPopularSearches || [];
    const { rentall, discover, hosting } = this.state;
    let becomeAHostLink = isAuthenticated ? '/become-a-owner?mode=new' : '/why-become-owner';
    return (
      <footer role="contentinfo">
        <div className={cx(s.bgImage, page === "search" && s.searchFooterWaveBg)} style={{ backgroundImage: `url(${whiteBg ? whiteFooter : bgImage})` }} />
        <div className={cx(s.bgImageSection, "hidden-print", page === "search" && s.searchFooterContainer)}>
          <div className={cx(whiteBg ? s.bgWhite : s.bgColor)} />
          <Grid fluid className={s.container}>
            <Row>
              <Col sm={12} md={12} lg={12} xs={12}>
                <div className={s.displayGrid}>
                  <div className={cs.spaceTop3}>
                    <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>{siteName}</label>
                    <ul className={s.listContainer}>
                      <li>
                        <Link to={'/about'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.about} />
                        </Link>
                      </li>
                      <li>
                        <Link to={'/contact'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.contactForm} />
                        </Link>
                      </li>
                      {
                        rentall && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                          if (item.footerCategory != 'discover' && item.footerCategory != 'hosting') {
                            return (
                              <li key={key}>
                                <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                  {getLocalizedContent(item, 'pageTitle', locale)}
                                </Link>
                              </li>
                            )
                          }
                        })
                      }
                    </ul>
                  </div>
                  <div className={cs.spaceTop3}>
                    <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                      <FormattedMessage {...messages.discover} />
                    </label>
                    <ul className={s.listContainer}>
                      <li>
                        <Link to={'/safety'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.trustSafety} />
                        </Link>
                      </li>
                      {
                        discover && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                          if (item.footerCategory == 'discover') {
                            return (
                              <li key={key}>
                                <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                  {getLocalizedContent(item, 'pageTitle', locale)}
                                </Link>
                              </li>
                            )
                          }
                        })
                      }
                    </ul>
                  </div>
                  <div className={cs.spaceTop3}>
                    <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                      <FormattedMessage {...messages.hosting} />
                    </label>
                    <ul className={s.listContainer}>
                      <li>
                        <Link to={becomeAHostLink} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.becomeAHost} />
                        </Link>
                      </li>
                      <li>
                        <Link to={'/privacy'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.termsPrivacy} />
                        </Link>
                      </li>
                      <li>
                        <Link to={'/terms-of-service'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                          <FormattedMessage {...messages.termsOfService} />
                        </Link>
                      </li>
                      {
                        hosting && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                          if (item.footerCategory == 'hosting') {
                            return (
                              <li key={key}>
                                <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                  {getLocalizedContent(item, 'pageTitle', locale)}
                                </Link>
                              </li>
                            )
                          }
                        })
                      }
                    </ul>
                  </div>
                  {/* Ubicaciones Populares - Dinámico desde DB */}
                  {popularLocations && popularLocations.length > 0 && (
                    <div className={cs.spaceTop3}>
                      <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                        <FormattedMessage {...messages.popularLocations} />
                      </label>
                      <ul className={s.listContainer}>
                        {popularLocations.filter(loc => loc.isEnable).slice(0, 6).map((location, index) => (
                          <li key={location.id || index}>
                            <Link
                              to={`/s?address=${encodeURIComponent(location.locationAddress || location.location)}`}
                              className={cx(cs.siteTextColor, cs.commonMediumText)}
                            >
                              {location.location}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {/* Experiencias - Top 10 búsquedas populares del AI Banner */}
                  {popularSearches && popularSearches.length > 0 && (
                    <div className={cs.spaceTop3}>
                      <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                        <FormattedMessage {...messages.experiences} />
                      </label>
                      <ul className={s.listContainer}>
                        {popularSearches.slice(0, 10).map((search, index) => (
                          <li key={search.id || index}>
                            <Link
                              to={`/s?address=${encodeURIComponent(search.searchQuery)}`}
                              className={cx(cs.siteTextColor, cs.commonMediumText)}
                            >
                              {search.searchQuery.split(' ').map(word =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                              ).join(' ')}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div className={cs.spaceTop3}>
                    {(facebook || twitter || instagram || youtube || linkedin) && <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}><FormattedMessage {...messages.followUsText} /></label>}
                    <div className={s.socialFlex}>
                      {
                        facebook && <a href={facebook} target='_blank' rel="noopener noreferrer" className={s.shareIcon} aria-label="Facebook">
                          <img src={facebookIcon} alt="" aria-hidden="true" />
                        </a>
                      }
                      {
                        twitter && <a href={twitter} target='_blank' rel="noopener noreferrer" className={cx(s.shareIcon, s.twitterMargin)} aria-label="Twitter">
                          <img src={twitterIcon} alt="" aria-hidden="true" />
                        </a>
                      }
                      {
                        instagram && <a href={instagram} target='_blank' rel="noopener noreferrer" className={s.shareIcon} aria-label="Instagram">
                          <img src={instaIcon} alt="" aria-hidden="true" />
                        </a>
                      }
                      {
                        youtube && <a href={youtube} target='_blank' rel="noopener noreferrer" className={s.shareIcon} aria-label="YouTube">
                          <img src={youtubeIcon} alt="" aria-hidden="true" />
                        </a>
                      }
                      {
                        linkedin && <a href={linkedin} target='_blank' rel="noopener noreferrer" className={s.shareIcon} aria-label="LinkedIn">
                          <img src={linkedinIcon} alt="" aria-hidden="true" />
                        </a>
                      }
                    </div>
                    {/* App Store / Play Store - debajo de redes sociales */}
                    {
                      appAvailableStatus && (playStoreUrl || appStoreUrl) &&
                      <div className={s.appStoreContainer}>
                        {
                          appStoreUrl && <a href={appStoreUrl} target='_blank' className={s.appStoreLink}>
                            <img alt='App Store' src={AppStoreImage} />
                          </a>
                        }
                        {
                          playStoreUrl && <a href={playStoreUrl} target='_blank' className={s.appStoreLink}>
                            <img alt='Play Store' src={PlayStoreImage} />
                          </a>
                        }
                      </div>
                    }
                  </div>
                </div>
                <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom6, cs.spaceTop6)} />
                <div className={cx(s.displayFlex, s.flexReverse)}>
                  <h4 className={cx(cs.commonSmallText, cs.fontWeightNormal, s.siteNamePadding)}>© {siteName}</h4>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </footer>
    );
  }
}


const mapState = state => ({
  siteName: state.siteSettings?.data?.siteName || '',
  facebook: state.siteSettings?.data?.facebookLink || '',
  twitter: state.siteSettings?.data?.twitterLink || '',
  instagram: state.siteSettings?.data?.instagramLink || '',
  youtube: state.siteSettings?.data?.youtubeLink || '',
  linkedin: state.siteSettings?.data?.linkedinLink || '',
  appAvailableStatus: state.siteSettings?.data?.appAvailableStatus == 1 || state.siteSettings?.data?.appAvailableStatus === '1' || state.siteSettings?.data?.appAvailableStatus === true,
  playStoreUrl: state.siteSettings?.data?.playStoreUrl || '',
  appStoreUrl: state.siteSettings?.data?.appStoreUrl || '',
  isAuthenticated: state.runtime?.isAuthenticated || false,
  locale: state.intl?.locale || 'es',
});

const mapDispatch = {
};


export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch),
  graphql(getEnabledBlog,
    {
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    }),
  graphql(getPopularLocations,
    {
      name: 'popularLocationsData',
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    }),
  graphql(getPopularSearches,
    {
      name: 'popularSearchesData',
      options: {
        variables: { limit: 10 },
        fetchPolicy: 'cache-and-network',
        ssr: false
      }
    }),
)(Footer);